import CalendarMarketingHomeSection from "../../Home/CalendarMarketingHomeSection";

const CalendarSectionB2C = (props) => {
  return (
    <CalendarMarketingHomeSection />
  );
};
export default CalendarSectionB2C;
